/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFerry = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 19a1.001 1.001 0 0 0-2 0c0 1.654-1.346 3-3 3s-3-1.346-3-3h2a1.001 1.001 0 0 0 1.86.51l-2.027-8.25L6 10.469v-5.47h5V2h2v2.999h5v5.47l3.167.792-2.028 8.248A1 1 0 0 0 21 19h2c0 1.654-1.346 3-3 3s-3-1.346-3-3a.995.995 0 0 0-.22-.625l-.073-.082a.998.998 0 0 0-.59-.286L16 18c-.551 0-1 .448-1 1 0 1.654-1.346 3-3 3s-3-1.346-3-3zm-3.833-6.261 1.155 3.775.026-.017.12-.075-.146.092a3.01 3.01 0 0 1 1.387-.5A2.878 2.878 0 0 1 8 16c1.654 0 3 1.346 3 3v-7.719l-5 1.25zM16 16c.066 0 .132.002.197.006L16 16a3.03 3.03 0 0 1 1.14.225 3.64 3.64 0 0 1 .335.163 1.784 1.784 0 0 1 .177.109.724.724 0 0 1 .026.017l1.155-3.775-.833-.207-5-1.251v7.69l.005-.147A3.004 3.004 0 0 1 16 16zm0-9H8v2.969l4-1 4 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFerry as Ferry };
